import { render, staticRenderFns } from "./PDPFAQs.vue?vue&type=template&id=20b6f161&scoped=true"
import script from "./PDPFAQs.vue?vue&type=script&lang=js"
export * from "./PDPFAQs.vue?vue&type=script&lang=js"
import style0 from "./PDPFAQs.vue?vue&type=style&index=0&id=20b6f161&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b6f161",
  null
  
)

export default component.exports